import { createContext } from "react";

export interface NavigationFeatureFlags {
	enableAnalytics: boolean;
	enableCaseManagement: boolean;
	enableSopManagement: boolean;
}

const defaultValue: NavigationFeatureFlags = {
	enableAnalytics: false,
	enableCaseManagement: false,
	enableSopManagement: false,
};

export const NavigationFeatureFlagsContext =
	createContext<NavigationFeatureFlags>(defaultValue);
